export default {

  name: 'baseUrl',
  data() {
    let baseURL = '';
    const api = location.hostname;
    switch (api) {
      case 'localhost':
        baseURL = 'http://localhost:8000/api/';
       // baseURL = 'http://localhost:8000/api/';
      break;
      case  'front-stage.hova.co.il':
        baseURL = 'https://api-stage.hova.co.il/api/';
      break;
      case  'front.10b.co.il':
        baseURL = 'https://api.10b.co.il/api/';
        break;
      default :
        baseURL = 'https://api.hova.co.il/api/';
    }
    return baseURL;
  }
}



